import { render, staticRenderFns } from "./ServiziBrevi.vue?vue&type=template&id=013a8a32&scoped=true&"
import script from "./ServiziBrevi.vue?vue&type=script&lang=js&"
export * from "./ServiziBrevi.vue?vue&type=script&lang=js&"
import style0 from "./ServiziBrevi.vue?vue&type=style&index=0&id=013a8a32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013a8a32",
  null
  
)

export default component.exports